import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Mail, Loader2, ArrowLeft, CheckCircle } from 'lucide-react';
import { API } from '../lib/constants';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="w-14 h-14 bg-[#1a1a1a] rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-[#16A34A] font-black text-2xl">O</span>
          </div>
          <h1 className="text-3xl font-black mb-2">Forgot password?</h1>
          <p className="text-white/50">Enter your email and we'll send you a reset link.</p>
        </div>

        {sent ? (
          <div className="text-center space-y-5" data-testid="forgot-sent-message">
            <CheckCircle className="h-14 w-14 text-[#16A34A] mx-auto" />
            <p className="text-white/80">If an account exists for <span className="font-bold">{email}</span>, a reset link is on its way. Check your inbox (and spam).</p>
            <Button onClick={() => navigate('/signin')} className="w-full bg-[#0F5132] hover:bg-[#0B3B24] text-white font-bold h-12 rounded-xl" data-testid="forgot-back-signin-btn">
              Back to Sign In
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-white/70 flex items-center gap-2">
                <Mail className="h-4 w-4" /> Email
              </label>
              <Input
                value={email}
                onChange={e => setEmail(e.target.value)}
                type="email"
                placeholder="you@email.com"
                data-testid="forgot-email-input"
                onKeyPress={e => e.key === 'Enter' && submit()}
                className="bg-white/5 border-white/10 text-white h-12 rounded-xl"
              />
            </div>
            <Button onClick={submit} disabled={!email || loading} data-testid="forgot-submit-btn"
              className="w-full bg-[#0F5132] hover:bg-[#0B3B24] text-white font-bold h-12 rounded-xl text-lg">
              {loading ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : null}
              Send Reset Link
            </Button>
            <button onClick={() => navigate('/signin')} className="w-full text-white/30 text-sm py-2 hover:text-white/50 flex items-center justify-center gap-1">
              <ArrowLeft className="h-3 w-3" /> Back to Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
